import { render, staticRenderFns } from "./ownerDetailCar.vue?vue&type=template&id=321c93fc&scoped=true"
import script from "./ownerDetailCar.vue?vue&type=script&lang=js"
export * from "./ownerDetailCar.vue?vue&type=script&lang=js"
import style0 from "./ownerDetailCar.vue?vue&type=style&index=0&id=321c93fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321c93fc",
  null
  
)

export default component.exports